import React from 'react';
import { NotAuthorizedErrorMessage } from 'components/error/NotAuthorizedErrorMessage';

export const UnauthorizedPage = () => <NotAuthorizedErrorMessage />;
